import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { useScreen, useUserData } from '../../../hooks'
import { isManagerUser } from '../../../utils/user'
import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../Formik'

import { getFieldDisabledProps } from './DocumentAccessField.utils'

import * as styles from './DocumentAccessField.module.css'

function DocumentAccessField({
  Field,
  fieldComponentProps,
  name,
  onChangeDwellerAccess,
  onChangeManagerAccess,
}) {
  const { t } = useTranslation()

  const { isSubmitting } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const user = useUserData()

  const isManagerUserAcc = isManagerUser(user)

  const disabledProps = {
    className: classNames(styles.disabledField, {
      [styles.submitting]: isSubmitting,
    }),
    iconClassName: styles.boundingClassName,
  }

  return (
    <div className={styles.AccessField}>
      <FormikField
        {...disabledProps}
        disabled
        showTooltip
        Component={Checkbox}
        Field={Field}
        fieldComponentProps={{
          ...fieldComponentProps,
          fieldInputClassName: styles.checkboxField,
          label: `${t('DocumentsFolder.AccessFieldLabelKey')}:`,
          labelClassName: styles.AccessFieldLabel,
          required: true,
          shouldAdaptToMobileScreen: true,
        }}
        getFieldDisabledProps={getFieldDisabledProps}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('DocumentsFolder.AccessAdminLabelKey')}
        name={name.admins}
        size={CHECKBOX_SIZE.small}
        tooltip={t('DocumentsFolder.AccessAdminTooltipKey')}
      />
      <FormikField
        {...(isManagerUserAcc ? disabledProps : null)}
        showTooltip
        Component={Checkbox}
        disabled={isManagerUserAcc}
        fieldComponentProps={{
          label: !Field && !isMobileScreenSize,
          shouldAdaptToMobileScreen: true,
        }}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('DocumentsFolder.AccessManagerLabelKey')}
        name={name.managers}
        size={CHECKBOX_SIZE.small}
        onChange={onChangeManagerAccess}
      />
      <FormikField
        Component={Checkbox}
        fieldComponentProps={{
          label: !Field && !isMobileScreenSize,
          shouldAdaptToMobileScreen: true,
        }}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('DocumentsFolder.AccessLandlordsLabelKey')}
        name={name.landlords}
        size={CHECKBOX_SIZE.small}
        onChange={onChangeDwellerAccess}
      />
      <FormikField
        Component={Checkbox}
        fieldComponentProps={{
          label: !Field && !isMobileScreenSize,
          shouldAdaptToMobileScreen: true,
        }}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('DocumentsFolder.AccessTenantsLabelKey')}
        name={name.tenants}
        size={CHECKBOX_SIZE.small}
        onChange={onChangeDwellerAccess}
      />
    </div>
  )
}

export default DocumentAccessField
